import React from "react";
import { PageTitle, Paragraph, ParaImageDialog, ParaTitle, Pagination } from "../common";

const TextReports = () => {
  return (
    <div>
      <PageTitle title='Text Reports' role='Risk Manager' />
      <ParaTitle paraTitle='How To Start' />
      <Paragraph paragraph='Admins/Approvers have access to many kinds of reports which are in graph and text formats regarding the events, locations and categories.' />
      
      <ParaTitle paraTitle='Text Reports' />
      <Paragraph paragraph='There are many different Text reports based on the "Event Category" and can be selected under "Reports" -> "Text" -> "select any report".' />
      <ParaImageDialog src='/tutorial_image/text-reports-1.png' />

      <ParaTitle paraTitle='Events Overview Report' />
      <Paragraph paragraph='An overview of all the events in a text report table. "Search" can search through the entire report in any column. Click on column headings to sort the columns. "Scroll" to find all/any records. Click on "any row" to expand it in detail.' />
      <ParaImageDialog src='/tutorial_image/text-reports-2.png' />

      <ParaTitle paraTitle='Blood or Blood Product' />
      <Paragraph paragraph='Apart from and overview report, there are several categorical reports in tabular form which are visible depending on the roles of the user. Here category "Blood or Blood Product" for demonstration. Other categorical reports follow similar formats and features. This report lists all the events for the category "Blood or Blood Product". Click on the row to expand and edit. Rest of the features remain same as other reports.' />
      <ParaImageDialog src='/tutorial_image/text-reports-3.png' />
      
      <Pagination
        pagination={{
          prev: { name: 'Graphical Reports', link: '/reports/graphical-reports' },
          next: { name: 'Password Reset', link: '/password-reset' }
        }}
      />
    </div>
  );
};

export default TextReports;
